import { render, staticRenderFns } from "./NotificatiMessage.vue?vue&type=template&id=f5e8c720&scoped=true&"
import script from "./NotificatiMessage.vue?vue&type=script&lang=js&"
export * from "./NotificatiMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotificatiMessage.vue?vue&type=style&index=0&id=f5e8c720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e8c720",
  null
  
)

export default component.exports